import React from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';

/**
 * Renders MUI Icon button to remove alert setting.
 * @returns {React.FC}
 */

const AlertItemActions = ({ deleteAlertItem }) => (
  <IconButton size="small" onClick={deleteAlertItem}>
    <Tooltip title="Delete alert setting">
      <DeleteIcon />
    </Tooltip>
  </IconButton>
);

export default AlertItemActions;

AlertItemActions.propTypes = {
  deleteAlertItem: PropTypes.func.isRequired
};
